import { supabase } from "@/integrations/supabase/client";

export type ProfileRow = {
  id: string;
  display_name: string | null;
  headline: string | null;
  location: string | null;
  onboarded_at: string | null;
  target_role: string | null;
  // Personal & contact
  first_name: string | null;
  last_name: string | null;
  phone: string | null;
  pronouns: string | null;
  // Social URLs (also derivable from sources, but explicit overrides live here)
  linkedin_url: string | null;
  github_url: string | null;
  portfolio_url: string | null;
  // Work authorization
  work_authorization: string | null;
  requires_sponsorship: boolean | null;
  // Voluntary self-identification (EEO)
  gender: string | null;
  race_ethnicity: string | null;
  hispanic_latino: boolean | null;
  veteran_status: string | null;
  disability_status: string | null;
  sexual_orientation: string | null;
};

const PROFILE_COLUMNS =
  "id,display_name,headline,location,onboarded_at,target_role,first_name,last_name,phone,pronouns,linkedin_url,github_url,portfolio_url,work_authorization,requires_sponsorship,gender,race_ethnicity,hispanic_latino,veteran_status,disability_status,sexual_orientation";

export const profileQueryKey = (userId: string) => ["profile", userId] as const;

export async function fetchProfile(userId: string): Promise<ProfileRow | null> {
  const { data, error } = await supabase
    .from("profiles")
    .select(PROFILE_COLUMNS)
    .eq("id", userId)
    .maybeSingle();
  if (error) throw error;
  return (data as unknown as ProfileRow) ?? null;
}

export async function updateProfile(userId: string, patch: Partial<ProfileRow>) {
  const { error } = await supabase
    .from("profiles")
    .update(patch as never)
    .eq("id", userId);
  if (error) throw error;
}

export async function markOnboarded(userId: string, targetRole: string | null) {
  const { error } = await supabase
    .from("profiles")
    .update({ onboarded_at: new Date().toISOString(), target_role: targetRole } as never)
    .eq("id", userId);
  if (error) throw error;
}
